import get from "lodash.get";
import styled from "styled-components";
import { INotificationCardStyled } from "./NotificationCard.types";

export const NotificationCardStyled = styled("div")<INotificationCardStyled>`
  padding: 10px 30px;
  transition: all 0.2s linear;
  position: relative;
  &:hover {
    background: ${({ theme }) => get(theme, "white.light")};
  }
  &::before {
    display: ${({ hasSeen }) => (hasSeen ? "none" : "block")};
    top: 50%;
    transform: translateY(-50%);
    left: 5px;
    position: absolute;
    content: "";
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: ${({ theme }) => get(theme, "success.dark")};
  }
  .notification-card-title {
    font-weight: 600;
    font-size: 15px;
    letter-spacing: 0.5px;
  }
  .notification-card-text {
    font-weight: 500;
    font-size: 15px;
  }
  time {
    font-size: 12px;
    font-weight: 500;
  }
  .card-message {
    font-size: 13px;
  }
`;
